import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=013e374e&scoped=true"
import script from "./RadioButton.vue?vue&type=script&lang=js"
export * from "./RadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013e374e",
  null
  
)

export default component.exports